import React from 'react';
import ReactDOM from 'react-dom';
import Mainui from './mainui';

ReactDOM.render(<Mainui />, document.querySelector('#root'));
    